/**
 *
 * Asynchronously loads the component for KioskProjectsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const KioskProjectsPage = lazyLoad(
  () => import('./index'),
  module => module.KioskProjectsPage,
);
